export default "__VITE_ASSET__CIHF6uiC__"